// STEP 2 · agent s2a2 — A8: AI units singular / plural (EN one / other; AR zero / one / two / few / many / other through
// fmtPlural, lib/format.js — the app's one plural helper, Intl.PluralRules). Loaded from lib/i18n/ by the generated index (STEP 2 · B2).
// Read by components/dashboard/FdBilling.jsx (dict.plurals.aiUnits).
export const I18N_S2A2 = {
  en: {
    plurals: {
      aiUnits: { one: "{n} unit", other: "{n} units" },
    },
  },
  ar: {
    plurals: {
      aiUnits: { zero: "{n} وحدة", one: "وحدة واحدة", two: "وحدتان", few: "{n} وحدات", many: "{n} وحدة", other: "{n} وحدة" },
    },
  },
};

export default I18N_S2A2;
